import { LOCAL_STORAGE_KEY_SESSION_KEY } from 'common/constants/constants'

export default () => localStorage.removeItem(LOCAL_STORAGE_KEY_SESSION_KEY)
